import { AUTH_API, COMPANY_API } from 'apis';
import {
  IQuickUserAuthParams,
  IQuickUserUseBulkParams,
  IQuickUserUseParams,
  IQuickUserUseResult
} from 'containers/Service/Quick/types';

// 퀵 주문 목록 조회
export const getQuickOrderList = async (params: unknown) => {
  const { data } = await COMPANY_API.get(`captain-payment/quick/v2/booking`, { params });
  return data;
};

// 퀵 배송 주문 생성
export const saveQuickOrder = async (params: unknown) => {
  const { data } = await COMPANY_API.post(`captain-payment/quick/v2/booking`, params);
  return data;
};

// 퀵 배송 예상 가격 조회
export const checkQuickOrderPrice = async (params: unknown) => {
  const { data } = await COMPANY_API.post(`captain-payment/quick/v2/booking/check`, params);
  return data;
};

// 퀵 주문 상세 조회
export const getQuickOrderDetail = async (quickIdx?: number) => {
  const { data } = await COMPANY_API.get(`captain-payment/quick/v2/booking/${quickIdx}`);
  return data;
};

// 퀵 배송 주문 취소
export const cancelQuickOrder = async (quickIdx: number) => {
  await COMPANY_API.delete(`captain-payment/quick/v2/booking/${quickIdx}`);
};

// 주소록 목록 조회
export const getAddressBookList = async (params: unknown) => {
  const { data } = await COMPANY_API.get(`/captain-payment/quick/v2/booking/address-book`, { params });
  return data;
};

// 주소록 항목 추가
export const saveAddressBook = async (params: unknown) => {
  await COMPANY_API.post(`captain-payment/quick/v2/booking/address-book`, params);
};

// 주소록 항목 삭제
export const deleteAddressBook = async (addressIdx: number) => {
  await COMPANY_API.delete(`captain-payment/quick/v2/booking/address-book/${addressIdx}`);
};

// 퀵 서비스 통계 조회
export const getQuickOrderStat = async (params: unknown) => {
  const { data } = await COMPANY_API.get(`/captain-payment/quick/v2/stat`, { params });
  return data;
};

// 퀵 주문 배송원 정보 조회
export const getPickerInfo = async (quickIdx?: number) => {
  const { data } = await COMPANY_API.get(`captain-payment/quick/v2/booking/picker/${quickIdx}`);
  return data;
};

// 퀵 사용자 권한 목록 조회
export const getQuickUserAuthList = async (params: IQuickUserAuthParams) => {
  const { data } = await COMPANY_API.get(`captain-payment/quick/v2/user-auth`, { params });
  return data;
};

// 사용자별 퀵 사용여부 변경
// 기존 menuAuthIdxList 에서 퀵 관련 idx 만 교체한 전체 목록을 보낸다
const putQuickUserUse = ({ userId, menuAuthIdxList }: IQuickUserUseParams) =>
  COMPANY_API.put(`captain-payment/quick/v2/user-auth/${userId}`, { menuAuthIdxList });

export const setQuickUserUse = async (params: IQuickUserUseParams) => {
  const { data } = await putQuickUserUse(params);
  return data;
};

// 결과 문구는 응답의 result.text 를 그대로 쓰고, 없으면 code·HTTP status 로 만든다
const toResultText = (result?: { code?: string; text?: string }, statusCode?: number) => {
  if (result && result.text) return result.text;

  const code = result && result.code;
  if (code) return statusCode ? `${code} (${statusCode})` : code;
  return statusCode ? `실패 (${statusCode})` : '실패';
};

// 선택 사용자 퀵 사용여부 일괄 변경
// 일괄 엔드포인트가 없어 사용자별 변경 API 를 반복 호출한다.
// TODO: 일괄 API 가 생기면 단일 요청으로 교체
export const setQuickUserUseBulk = async ({ users, onProgress }: IQuickUserUseBulkParams) => {
  // userId → 결과. 모달에서 행별 결과 문구를 표시하는 데 쓴다
  const results: Record<string, IQuickUserUseResult> = {};
  let failedCount = 0;

  // 동시 요청으로 서버 부담을 주지 않도록 한 건씩 순서대로 처리한다
  // eslint-disable-next-line no-restricted-syntax
  for (const user of users) {
    let result: IQuickUserUseResult;

    try {
      // eslint-disable-next-line no-await-in-loop
      const res = await putQuickUserUse(user);
      result = { ok: true, text: toResultText(res.data && res.data.result, res.status) };
    } catch (e) {
      const response = e && e.response;
      result = {
        ok: false,
        text: toResultText(response && response.data && response.data.result, response && response.status)
      };
      failedCount += 1;
    }

    results[user.userId] = result;
    if (onProgress) onProgress(Object.keys(results).length, users.length);
  }

  return { results, failedCount };
};

export const getTermLatest = async (params: unknown) => {
  const { data } = await AUTH_API.get(`common/term/v1/latest`, { params });
  return data;
};

export const getTerm = async (params: unknown) => {
  const { data } = await AUTH_API.get(`common/term/v1`, { params });
  return data;
};

export const getTermDate = async (params: unknown) => {
  const { data } = await AUTH_API.get(`common/term/v1/date`, { params });
  return data;
};
